import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, unref as _unref, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }

import { PropType, ref, computed } from "vue";
  import { Platform } from "quasar";

  import { useProposalStore } from "src/stores/proposal-store";
  import { useSettingsStore } from "src/stores/settings-store";

  import { ApplicationFilters } from "src/types/controls/index";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationFilter',
  props: {
    filters: {
      type: Object as PropType<ApplicationFilters>,
      default: null
    }
  },
  setup(__props) {

  const settingsStore = useSettingsStore();
  const proposalStore = useProposalStore();

  const props = __props

  const isMobile = computed(() => settingsStore.isMobile);

  const decisionOptions = ref([
    "Approved",
    "Approved (Predicted)",
    "Approved (Conditionally)",
    "Awaiting Decision",
    "Failed Vehicle Rule",
    "Proposals Expired",
    "Declined"
  ])
  const statusOptions = ref([
    { label: "Quick Quote", value: -1 },
    { label: "Underwriting", value: 0 },
    { label: "Manual Review", value: 1 },
    { label: "Ready To Deal", value: 2 },
    { label: "Unable To Contact", value: 3 },
    { label: "NTU No Contact", value: 4 },
    { label: "NTU Rate Too High", value: 5 },
    { label: "NTU Lost To Competitor", value: 6 },
    { label: "NTU Outside Criteria", value: 7 },
    { label: "NTU Other", value: 8 },
    { label: "Awaiting Payout", value: 9 },
    { label: "Completed", value: 10 },
  ])
  const createdOptions = ref([
    { label: "30 Days", value: 30 },
    { label: "60 Days", value: 60 },
    { label: "90 Days", value: 90 },
    { label: "All Time", value: 365 },
  ])
  function reset() {
    props.filters.decision = [];
    props.filters.status = [];
    props.filters.createdBy = [];
    props.filters.date = 30;
    props.filters.text = "";
  }
  const createdByOptions = computed(() => [...new Set(proposalStore.applications.map(a => a.createdBy))]);

  const applied = computed(() => settingsStore.customerFiltersApplied > 0 ? settingsStore.customerFiltersApplied : 0);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex row items-center", isMobile.value ? 'justify-between' : ''])
  }, [
    (isMobile.value)
      ? (_openBlock(), _createBlock(_component_q_input, {
          key: 0,
          dense: "",
          outlined: "",
          color: "primary",
          debounce: "500",
          style: {"min-width":"220px"},
          placeholder: "Search",
          clearable: "",
          modelValue: __props.filters.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.filters.text) = $event)),
          "bg-color": "white"
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "mdi-magnify",
              color: "primary"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_btn_dropdown, {
      color: "primary",
      flat: "",
      dense: "",
      icon: "mdi-filter-variant",
      class: "text-weight-bold brand-button",
      label: 'Filter'+(applied.value > 0 ? ' ('+applied.value+')' : '')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "shadow-9",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, {
              style: {"min-width":"240px"},
              class: "q-py-sm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-uppercase text-overline q-mb-xs" }, "Decision", -1)),
                        _createVNode(_component_q_select, {
                          outlined: "",
                          color: "primary",
                          dense: "",
                          multiple: "",
                          "popup-content-class": "text-body2",
                          options: decisionOptions.value,
                          modelValue: __props.filters.decision,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.filters.decision) = $event)),
                          "display-value": __props.filters.decision !== null && __props.filters.decision.length === 1 ? decisionOptions.value.find(d => d === __props.filters.decision![0]) : __props.filters.decision !== null && __props.filters.decision.length > 1 ? (__props.filters.decision.length + ' Selected') : '',
                          "emit-value": ""
                        }, {
                          option: _withCtx(({ itemProps, opt, selected, toggleOption }) => [
                            _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(itemProps)), {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_label, { innerHTML: opt }, null, 8, ["innerHTML"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_q_item_section, { side: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_toggle, {
                                      "model-value": selected,
                                      "onUpdate:modelValue": ($event: any) => (toggleOption(opt))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        }, 8, ["options", "modelValue", "display-value"])
                      ]),
                      _: 1,
                      __: [6]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-uppercase text-overline q-mb-xs" }, "Status", -1)),
                        _createVNode(_component_q_select, {
                          outlined: "",
                          color: "primary",
                          dense: "",
                          multiple: "",
                          "popup-content-class": "text-body2",
                          options: statusOptions.value,
                          modelValue: __props.filters.status,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.filters.status) = $event)),
                          "display-value": __props.filters.status !== null && __props.filters.status.length === 1 ? statusOptions.value.find(d => d.value === __props.filters.status![0])!.label : __props.filters.status !== null && __props.filters.status.length > 1 ? (__props.filters.status.length + ' Selected') : '',
                          "emit-value": ""
                        }, {
                          option: _withCtx(({ itemProps, opt, selected, toggleOption }) => [
                            _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(itemProps)), {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_label, {
                                      innerHTML: opt.label
                                    }, null, 8, ["innerHTML"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_q_item_section, { side: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_toggle, {
                                      "model-value": selected,
                                      "onUpdate:modelValue": ($event: any) => (toggleOption(opt))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        }, 8, ["options", "modelValue", "display-value"])
                      ]),
                      _: 1,
                      __: [7]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-uppercase text-overline q-mb-xs" }, "Created", -1)),
                        _createVNode(_component_q_select, {
                          outlined: "",
                          color: "primary",
                          dense: "",
                          "popup-content-class": "text-body2",
                          options: createdOptions.value,
                          modelValue: __props.filters.date,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.filters.date) = $event)),
                          "display-value": __props.filters.date !== null ? createdOptions.value.find(d => d.value === __props.filters.date) ? createdOptions.value.find(d => d.value === __props.filters.date)!.label : '': '',
                          "emit-value": ""
                        }, null, 8, ["options", "modelValue", "display-value"])
                      ]),
                      _: 1,
                      __: [8]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-uppercase text-overline q-mb-xs" }, "Created by", -1)),
                        _createVNode(_component_q_select, {
                          modelValue: __props.filters.createdBy,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.filters.createdBy) = $event)),
                          options: createdByOptions.value,
                          outlined: "",
                          "popup-content-class": "text-body2",
                          multiple: "",
                          "bg-color": "white",
                          "display-value": __props.filters.createdBy !== null && __props.filters.createdBy.length === 1 ? createdByOptions.value.find(d => d === __props.filters.createdBy![0]) : __props.filters.createdBy !== null && __props.filters.createdBy.length > 1 ? (__props.filters.createdBy.length + ' Selected') : '',
                          style: {"max-width":"320px"},
                          dense: ""
                        }, {
                          option: _withCtx(({ itemProps, opt, selected, toggleOption }) => [
                            _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(itemProps)), {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_label, { innerHTML: opt }, null, 8, ["innerHTML"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_q_item_section, { side: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_toggle, {
                                      "model-value": selected,
                                      "onUpdate:modelValue": ($event: any) => (toggleOption(opt))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "display-value"])
                      ]),
                      _: 1,
                      __: [9]
                    })
                  ]),
                  _: 1
                }),
                (isMobile.value || _unref(Platform).is.ipad)
                  ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_btn, {
                          outline: "",
                          class: "text-subtitle1 brand-button full-width",
                          disable: applied.value === 0,
                          color: "primary",
                          label: "Reset Filters",
                          onClick: reset
                        }, null, 8, ["disable"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["label"]),
    (!isMobile.value && !_unref(Platform).is.ipad)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_btn, {
            flat: "",
            class: "text-subtitle1 brand-button",
            color: "primary",
            disable: applied.value === 0,
            label: "Reset Filters",
            onClick: reset
          }, null, 8, ["disable"])
        ]))
      : _createCommentVNode("", true),
    (!isMobile.value)
      ? (_openBlock(), _createBlock(_component_q_input, {
          key: 2,
          dense: "",
          outlined: "",
          color: "primary",
          debounce: "500",
          style: {"min-width":"260px"},
          placeholder: "Search by customer or VRM…",
          class: _normalizeClass(_unref(Platform).is.ipad ? 'q-ml-sm' : ''),
          modelValue: __props.filters.text,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.filters.text) = $event)),
          "bg-color": "white"
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, { name: "mdi-magnify" })
          ]),
          _: 1
        }, 8, ["class", "modelValue"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})